var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "column page-top-banner" },
    [
      _c("h2", { staticClass: "page-sub-title" }, [
        _vm._v("\n    " + _vm._s(_vm.headerTitle) + "\n  ")
      ]),
      _vm._v(" "),
      _vm.headerContent
        ? _c("p", { staticClass: "small-12 column" }, [
            _vm._v("\n    " + _vm._s(_vm.headerContent) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }